export const mapPrice = (price = {}) => {
  if (price.isOutletPrice) {
    return price.rrp;
  }

  if (price.isMarkedDown) {
    return price.previous;
  }

  return price.current;
};

export const mapReducedPrice = (price = {}) =>
  price.isOutletPrice || price.isMarkedDown ? price.current.value : null;
